import {
  type DefaultError,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import {
  type ProofOfWorkParams,
  getProofOfWorkListFn,
} from './get-proof-of-work';
import type { ProofOfWork } from './types';

export const useGetProofOfWork = (
  params: ProofOfWorkParams,
  otps?: Omit<UseQueryOptions<ProofOfWork[], DefaultError>, 'queryKey'>
) => {
  return useQuery<ProofOfWork[], DefaultError>({
    queryKey: ['getProofOfWork', params],
    queryFn: () => getProofOfWorkListFn(params),
    ...otps,
  });
};
